import axios from 'axios';

export interface Counts {total: number; customers: number; providers: number}
export interface RegistrationFilters {from: string; to: string; role: string; area: string; interval: string; verified: string; q: string}
export interface RegistrationSummary {
  timezone: string; generatedAt: string; from: string; to: string; interval: string;
  totals: Counts; previous: Counts; today: Counts; week: Counts; previousFrom: string; previousTo: string;
  trend: (Counts & {date: string})[]; areas: (Counts & {slug: string; name: string})[]; definitions: string;
}
export interface RegistrationRow {_id: string; firstName?: string; lastName?: string; email: string; phoneNumber?: string;
  address?: string; state?: string; areaMatches?: string[];
  accountType: string; createdAt: string; area: string; isEmailVerified: boolean; isVerified: string; active: boolean; supended: boolean}
export interface RegistrationList {rows: RegistrationRow[]; total: number; page: number; pageSize: number}
export const lagosDate = (date = new Date()) => new Date(+date + 3600000).toISOString().slice(0, 10);
export function registrationDefaults(): RegistrationFilters {
  return {from: lagosDate(new Date(Date.now() - 29 * 86400000)), to: lagosDate(), role: 'all', area: 'all', interval: 'day', verified: 'all', q: ''};
}
export async function registrations<T>(path: string, filters: Partial<RegistrationFilters> & {page?: number}, signal?: AbortSignal): Promise<T> {
  try {
    return (await axios.get<T>(`${process.env.REACT_APP_BASE_URL}/admin/registrations${path}`, {params: filters, signal, withCredentials: true, timeout: 25000})).data;
  } catch (error: any) {
    if (axios.isCancel(error)) throw error;
    throw new Error(error.response?.data?.message || error.response?.data?.error?.message || 'Registrations are unavailable. Please retry.');
  }
}
export async function exportRegistrations(filters: RegistrationFilters) {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/registrations/export`, {params: filters, responseType: 'blob', withCredentials: true, timeout: 30000});
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a'); link.href = url; link.download = `registrations-${filters.from}-to-${filters.to}.csv`;
  document.body.appendChild(link); link.click(); link.remove(); URL.revokeObjectURL(url);
}
